// src/composables/deviceShared.js
import { ref, computed } from 'vue'

const userAgent = navigator.userAgent || ''
const _isiOS = ref(/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)

export const isIOS = computed(() => _isiOS.value)
